import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider } from 'antd'
import { ObjectiveStatus, ObjectiveDto } from '../../../../types'
import PerSpacer from '../../../../components/custom_components/Spacer'
import { ClosedTargetsTable } from './ClosedTargetsTable'
import { filterObjectivesByTypeStatusAndRefYear } from '../util'
import { PerCollapse } from '../../../../components/custom_components/Collapse'
import { useTargetsModalStore } from '../../../../components/custom_components/TargetsModal/TargetsModalStore'
import { TargetModalType } from '../../../../components/custom_components/TargetsModal/types'
import shallow from 'zustand/shallow'
import { retrieveCurrencyConversionRate } from '../../../../shared/currencyConversionUtil'
import { useCurrency } from '../../../../context/currency-context'

interface Props {
  objectives: ObjectiveDto[]
}

export const ClosedTargetsComponent: FC<Props> = ({ objectives }) => {
  const [t] = useTranslation()
  const [openTargetModal] = useTargetsModalStore((state) => [state.openTargetModal], shallow)
  const { currency: currentContractCurrency, currencyConversionData } = useCurrency()

  const closedMonetaryObjectives = filterObjectivesByTypeStatusAndRefYear(objectives, true, [
    ObjectiveStatus.Closed,
    ObjectiveStatus.ReadyForPayOff,
  ])
  const closedDevelopmentObjectives = filterObjectivesByTypeStatusAndRefYear(objectives, false, [ObjectiveStatus.Closed])

  return (
    <>
      {(!!closedMonetaryObjectives.length || !!closedDevelopmentObjectives.length) && (
        <>
          <Divider />
          <PerSpacer my="m">
            <PerCollapse
              panels={[
                {
                  heading: t('appraisalMeeting.closedTargetsOverview.header'),
                  content: (
                    <>
                      {!!closedMonetaryObjectives.length && (
                        <PerSpacer mb="s">
                          <ClosedTargetsTable
                            monetary
                            objectives={closedMonetaryObjectives}
                            onObjectiveViewClick={(objective) =>
                              openTargetModal(
                                TargetModalType.viewTargetInMeeting,
                                objective,
                                objective.currency
                                  ? retrieveCurrencyConversionRate(objective.currency, currentContractCurrency, currencyConversionData)
                                  : undefined,
                              )
                            }
                          />
                        </PerSpacer>
                      )}
                      {!!closedDevelopmentObjectives.length && (
                        <ClosedTargetsTable
                          objectives={closedDevelopmentObjectives}
                          onObjectiveViewClick={(objective) => openTargetModal(TargetModalType.viewTargetInMeeting, objective)}
                        />
                      )}
                    </>
                  ),
                },
              ]}
            />
          </PerSpacer>
        </>
      )}
    </>
  )
}
